import { render, staticRenderFns } from "./KioskDuplicate.vue?vue&type=template&id=2ac9a130&"
import script from "./KioskDuplicate.vue?vue&type=script&lang=js&"
export * from "./KioskDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./KioskDuplicate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports